module.exports = __webpack_public_path__ + "static/media/kr.13471669.svg";